import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Quote, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
const TESTIMONIALS = [{
  quote: "Working with Down Home Interiors transformed our house into a home. Denise's attention to detail and understanding of our style was remarkable. She listened to what we wanted and delivered beyond our expectations.",
  author: 'Sarah Mitchell',
  location: 'Brighton, MI',
  project: 'Full Home Design'
}, {
  quote: 'The staging services helped us sell our home in record time and for well above asking price. The transformation was incredible—buyers could immediately see themselves living there.',
  author: 'Michael & Jennifer Thompson',
  location: 'Howell, MI',
  project: 'Real Estate Staging'
}, {
  quote: 'From consultation to installation, the team made the entire process seamless. Our living room has never looked better, and we actually use the space now in ways we never did before.',
  author: 'Patricia Lawrence',
  location: 'Hartland, MI',
  project: 'Living Room Redesign'
}, {
  quote: "I've been shopping at Down Home Interiors for years. The curated selection is always on point, and the staff genuinely cares about helping you find the right pieces for your home.",
  author: 'Robert Chen',
  location: 'Howell, MI',
  project: 'Retail Customer'
}, {
  quote: "Denise helped us navigate a complete kitchen renovation. Her expertise in space planning and material selection was invaluable. The result is a kitchen that's both beautiful and incredibly functional.",
  author: 'Amanda & David Rodriguez',
  location: 'Fowlerville, MI',
  project: 'Kitchen Renovation'
}, {
  quote: 'The custom window treatments Down Home created for our home are stunning. They perfectly balance privacy and natural light while adding an elegant finishing touch to every room.',
  author: 'Elizabeth Warren',
  location: 'Brighton, MI',
  project: 'Window Treatments'
}, {
  quote: "We've worked with Down Home Interiors on three different properties over the years. Their consistency, professionalism, and design expertise keep us coming back.",
  author: 'James & Carol Peterson',
  location: 'Howell, MI',
  project: 'Multiple Projects'
}, {
  quote: 'As a real estate agent, I recommend Down Home Interiors to all my clients who need staging or design services. They understand what buyers want to see and deliver results that sell homes.',
  author: 'Linda Martinez',
  location: 'Livingston County, MI',
  project: 'Real Estate Professional'
}, {
  quote: 'Denise took our dated master bedroom and turned it into a serene retreat. The before and after is like night and day. We look forward to going to bed every night now!',
  author: 'Susan & Mark Johnson',
  location: 'Hartland, MI',
  project: 'Bedroom Design'
}, {
  quote: 'The design consultation was worth every penny. In just two hours, Denise gave us a clear plan and the confidence to move forward with our project. Her expertise saved us from costly mistakes.',
  author: 'Rachel Green',
  location: 'Howell, MI',
  project: 'Design Consultation'
}, {
  quote: 'Down Home Interiors designed our commercial office space with the same care they bring to residential projects. Our clients consistently compliment the professional yet welcoming atmosphere.',
  author: 'Thomas Anderson',
  location: 'Howell, MI',
  project: 'Commercial Design'
}, {
  quote: "We've been customers for over a decade. The quality of products, the design expertise, and the personal service keep us loyal. Down Home Interiors is a true gem in our community.",
  author: 'Margaret & William Davis',
  location: 'Brighton, MI',
  project: 'Long-term Client'
}];
export function Testimonials() {
  return <Layout data-id="element-544">
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100 border-b border-taupe-200" data-id="element-545">
        <div className="max-w-4xl mx-auto text-center" data-id="element-546">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-547">
            Client Testimonials
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-548">
            What Our Clients
            <br data-id="element-549" />
            <span className="italic" data-id="element-550">Are Saying</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-551">
            Two decades of trust, hundreds of satisfied clients, and
            relationships that last beyond the project.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-4 bg-white border-b border-taupe-200" data-id="element-552">
        <div className="max-w-4xl mx-auto text-center" data-id="element-553">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal-900 mb-6" data-id="element-554">
            Built on Trust and Results
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-555">
            Our reputation has been built one satisfied client at a time. Many
            of our customers return for multiple projects over the years, and
            referrals from happy clients remain our primary source of new
            business.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-556">
            These testimonials represent real feedback from real projects. We're
            proud of the relationships we've built and the spaces we've created
            together.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-557">
        <div className="max-w-7xl mx-auto" data-id="element-558">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-559">
            {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white p-8 border border-taupe-200 shadow-card relative flex flex-col" data-id="element-560">
                <Quote className="absolute top-6 left-6 text-sage-200 h-10 w-10" data-id="element-561" />

                <div className="relative z-10 pt-10 flex-grow" data-id="element-562">
                  <p className="text-charcoal-900/70 italic mb-6 leading-relaxed" data-id="element-563">
                    "{testimonial.quote}"
                  </p>
                </div>

                <div className="border-t border-taupe-100 pt-6 mt-4" data-id="element-564">
                  <div className="flex items-center gap-1 mb-3" data-id="element-565">
                    {[...Array(5)].map((_, i) => <Star key={i} className="text-sage-500 fill-sage-500" size={14} data-id="element-566" />)}
                  </div>
                  <p className="font-serif font-medium text-charcoal-900 mb-1" data-id="element-567">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-charcoal-900/50 uppercase tracking-wide mb-1" data-id="element-568">
                    {testimonial.location}
                  </p>
                  <p className="text-xs text-sage-600 italic" data-id="element-569">
                    {testimonial.project}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 px-4 bg-white" data-id="element-570">
        <div className="max-w-5xl mx-auto" data-id="element-571">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center" data-id="element-572">
            <div data-id="element-573">
              <div className="text-5xl font-serif text-sage-500 mb-3" data-id="element-574">20+</div>
              <p className="text-lg text-charcoal-900/70" data-id="element-575">Years in Business</p>
            </div>
            <div data-id="element-576">
              <div className="text-5xl font-serif text-sage-500 mb-3" data-id="element-577">500+</div>
              <p className="text-lg text-charcoal-900/70" data-id="element-578">Projects Completed</p>
            </div>
            <div data-id="element-579">
              <div className="text-5xl font-serif text-sage-500 mb-3" data-id="element-580">95%</div>
              <p className="text-lg text-charcoal-900/70" data-id="element-581">
                Client Referral Rate
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-582">
        <div className="max-w-4xl mx-auto text-center" data-id="element-583">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-584">
            Ready to Join Our Family of Satisfied Clients?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-585">
            Let's start a conversation about your design needs. We'd love to add
            your success story to our portfolio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-586">
            <Link to="/contact" data-id="element-587">
              <Button size="lg" className="min-w-[200px]" data-id="element-588">
                Schedule Consultation
              </Button>
            </Link>
            <Link to="/store-info" data-id="element-589">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-590">
                Visit Our Showroom
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}